$(function() {
  function update_codes(codes_field) {
    var selection = codes_field.val();
    var code_abbr = codes_field.children("option[value='" + selection + "']").text();
    var text = code_abbr;
    switch (selection) {
      case 'DAP':
        text = text + ' ' + codes_field.data('end-city');
        break;
      case 'FCA':
        text = text + ' ' + codes_field.data('start-city');
        break;
      case 'FOB':
        if (codes_field.data('start-city') === 'Madison Heights') {
          text = text + ' ' + codes_field.data('start-city');
        }
        break;
    }
    $('#alternative_i_order_delivery_terms').val(text);
  }

  $('#alternative_show_transport_price').on('change', function() {
    if ($(this).is(':checked')) {
      $('#alternative_i_delivery_terms_code').val('DAP');
    } else {
      $('#alternative_i_delivery_terms_code').val('FCA');
    }
    update_codes($('#alternative_i_delivery_terms_code'));
  });

  $('#alternative_i_delivery_terms_code').on('change', function() {
    update_codes($(this));
  });

  // If the new alternative has invalid fields, after reload the page doesn't display correctly the delivery code and terms.
  if ($('#new_alternative').length && $('#alternative_show_transport_price').is(':checked')) {
    $('#alternative_i_delivery_terms_code').val('DAP');
    update_codes($('#alternative_i_delivery_terms_code'));
  }
});
